module.exports = __webpack_public_path__ + "img/St-Vincent-and-Grandines.dd6abf25.png";